exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 701px) {\nbody.sidebar-collapsed .notifications {\n    top: 118px;\n    left: 12px;\n}\nbody.sidebar-collapsed .notifications .notifications-button {\n    width: 36px;\n    height: 36px;\n}\nbody.sidebar-collapsed .notifications .badge {\n    box-shadow: 0 0 0 2px #fafafc;\n}\nbody.sidebar-collapsed .notifications .backdrop:before {\n    left: 60px;\n}\nbody.sidebar-collapsed .notifications .popup {\n    left: 72px;\n    top: 110px;\n    max-height: calc(100vh - 130px);\n}\nbody.sidebar-collapsed.has-notifications-bell .header .navbar-content {\n    margin-top: 52px;\n}\n}\n", ""]);

// exports
